import * as React from "react";

import type { ForwardRefComponent } from "@fluentui/react-components";
import type { TabListProps } from "./TabList.types";
import { useTabListContextValues_unstable } from "@fluentui/react-components";
import { useTabListStyles } from "./useTabListStyles.styles";
import { useTablist } from "./useTabList";
import { renderTabList } from "./renderTabList";

export const TabList: ForwardRefComponent<TabListProps> = React.memo(
  React.forwardRef<HTMLElement, TabListProps>((props, ref) => {
    const state = useTablist(props, ref);
    const contextValues = useTabListContextValues_unstable(state);
    useTabListStyles(state);
    return renderTabList(state, contextValues);
  })
) as ForwardRefComponent<TabListProps>;

TabList.displayName = "next/TabList";
